import type { SupportChannelPayload } from './types';

/**
 * Extrai o link do canal de atendimento a partir da resposta de
 * `GET /v2/supportSector`. Aceita as chaves `url`, `chatUrl` ou `supportUrl`,
 * inclusive quando aninhadas dentro de `data`.
 *
 * Função pura (sem dependência do cliente axios) para ser testável e importável
 * em ambientes que não transformam `import.meta` (ex.: Jest).
 */
export function resolveSupportChannelUrl(payload: SupportChannelPayload | null | undefined): string | null {
  if (!payload) return null;
  const candidates = [
    payload.url,
    payload.chatUrl,
    payload.supportUrl,
    payload.data?.url,
    payload.data?.chatUrl,
    payload.data?.supportUrl
  ];
  const found = candidates.find((value) => typeof value === 'string' && value.trim().length > 0);
  return found ? found.trim() : null;
}
